<template>
	<TransitionRoot appear :show="show" as="template">
		<Dialog
			as="div"
			class="prose relative z-[1000] max-w-none antialiased"
			:show="show"
			@close="onClose"
		>
			<TransitionChild
				as="template"
				enter="duration-300 ease-out"
				enter-from="opacity-0"
				enter-to="opacity-100"
				leave="duration-200 ease-in"
				leave-from="opacity-100"
				leave-to="opacity-0"
			>
				<div class="fixed inset-0 bg-black bg-opacity-25" />
			</TransitionChild>

			<div class="fixed inset-0 overflow-y-auto">
				<div
					class="flex min-h-full items-center justify-center p-4 text-center"
				>
					<TransitionChild
						as="template"
						enter="duration-300 ease-out"
						enter-from="opacity-0 scale-95"
						enter-to="opacity-100 scale-100"
						leave="duration-200 ease-in"
						leave-from="opacity-100 scale-100"
						leave-to="opacity-0 scale-95"
					>
						<DialogPanel
							class="w-full transform overflow-hidden text-left align-middle transition-all"
							:class="[
								maxWidth,
								rounded,
								padding,
								backgroundColor,
							]"
						>
							<div
								v-if="showClose"
								class="absolute right-3 top-3 justify-end xl:flex"
							>
								<span class="cursor-pointer" @click="onClose">
									<IconTimes
										class="h-5 w-5 text-gray-650 hover:text-blue-400"
									/>
								</span>
							</div>

							<DialogTitle v-if="showTitle" as="div" class="">
								<slot name="title" />
							</DialogTitle>

							<slot name="content" />
						</DialogPanel>
					</TransitionChild>
				</div>
			</div>
		</Dialog>
	</TransitionRoot>
</template>

<script setup>
import { onMounted } from 'vue'
import {
	TransitionRoot,
	TransitionChild,
	Dialog,
	DialogPanel,
	DialogTitle,
} from '@headlessui/vue'
import IconTimes from '@/assets/svg/common/ico-times.svg'

const props = defineProps({
	showTitle: {
		type: Boolean,
		default: true,
		required: false,
	},
	showClose: {
		type: Boolean,
		default: true,
		required: false,
	},
	show: {
		type: Boolean,
		required: true,
	},
	maxWidth: {
		type: String,
		default: 'max-w-lg',
		required: false,
	},
	rounded: {
		type: String,
		default: 'rounded',
		required: false,
	},
	padding: {
		type: String,
		default: 'p-6',
		required: false,
	},
	shadow: {
		type: String,
		default: 'shadow-xl',
		required: false,
	},
	backgroundColor: {
		type: String,
		default: 'bg-white',
		required: false,
	},
})

const emit = defineEmits(['close'])

const onClose = () => {
	emit('close')
}

onMounted(async () => {})
</script>
